import { Input, Text } from "@fragments";
import { WidgetsRounded } from "@mui/icons-material";

const TYPE_OPTIONS = [
    {
        value: "CHALLENGE",
        label: "Desafio",
        description:
            "Crie um desafio com data de início e data de fim. Neste modo você pode rankear interações no grupo.",
    },
    {
        value: "LIFETIME",
        label: "Lifetime",
        description:
            "Neste modo as interações não serão gamificadas, e o grupo não terá uma data de início / fim.",
    },
];

export default function TypeSelector({ value, onChange }) {
    return (
        <>
            <Text.h3
                value="Tipo de grupo"
                className="mt-5 mb-1"
                grow
                left={<WidgetsRounded />}
            />
            <Input.Choices
                value={value}
                onInput={onChange}
                options={TYPE_OPTIONS}
            />
        </>
    );
}
